import React from "react";
import { withNamespaces } from "react-i18next";

import { Button, Card, CardBody, CardFooter, CardImg } from "reactstrap";
import ClockIcon from "../../assets/icons/clockIcon.png";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_TIME_FORMAT } from "src/common/constants";

const PlatformUpdateCard = (props) => {
    const { t, update, setSelectedUpdate } = props;
    const dateUtils = new DateUtils();

    return (
        <Card key={update.link}>
            <CardImg
                src={update.image}
                className="img-fluid"
                alt={update.title}
            />
            <CardBody className="p-0">
                <p className="px-3 pt-2">
                    <span dangerouslySetInnerHTML={{ __html: update.title }} />
                </p>
                <CardFooter className="bg-transparent d-flex flex-row justify-content-between align-items-center border-top">
                    <div className="text-muted">
                        <span className="pe-2">
                            <img src={ClockIcon} alt="icon" width={24} height={24} />
                        </span>
                        <span>
                            {dateUtils.convertDateToDate(update.createdAt, INTERNATIONAL_DATE_TIME_FORMAT)}
                        </span>
                    </div>
                    <Button 
                        onClick={() => setSelectedUpdate(update)}
                        outline
                        color="primary"
                        size="sm"
                        className="border-0"
                    >
                        {t("Read more")}
                    </Button>
                </CardFooter>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(PlatformUpdateCard);
